import React, { useContext, useImperativeHandle, useState, useMemo } from 'react';
import { Button, Modal, Space, Steps, message } from 'antd';
import CustomRecordList from '../CustomRecordList';
import SPFilterRecordList from '../SPFilterRecordList';

const componentsRecordList = {
  sp: SPFilterRecordList,
  custom: CustomRecordList,
};

class FilterRecordList extends React.Component<any> {
  render() {
    const { filterProps } = this.props;
    const listType = filterProps?.filterTable ? 'custom' : 'sp';
    return React.createElement(componentsRecordList[listType], { ...this.props }, null);
  }
}

export default FilterRecordList;
